import { createSelector } from "@reduxjs/toolkit";
import { initialState, type DashboardState } from "./slice";

const dashboardInitialState = (state: {
  dashboard?: DashboardState;
}): DashboardState => state.dashboard || initialState;

export const selectSummary = createSelector(
  [dashboardInitialState],
  (state) => state.summary,
);

export const selectCalls = createSelector(
  [dashboardInitialState],
  (state) => state.calls,
);

export const selectCallDetails = createSelector(
  [dashboardInitialState],
  (state) => state.details,
);
